import { Block, Flex, SimpleInput, Typography } from '@aloft/toolkit-sui';

import { Controller } from 'react-hook-form';

import { useZodFormContext } from '../../hooks/useZodForm.ts';

export const CustomMultiplier = () => {
  const { control, formState: { errors } } = useZodFormContext()
  return (
    <Flex flexDirection="column" gap="0.5rem">
      <Typography variant="h3">Custom Multiplier</Typography>
      <Typography variant="body1">
        If you have builder data for your market or are working on a high-end home exceeding the
        highest Craftsman quality data, you can apply a custom multiplier to adjust costs. This
        multiplier will be applied on top of the zip code multiplier and will apply to the cost data
        of all property features.
      </Typography>
      <Block marginLeft="0.5rem">
        <Controller
          name="costMultiplier"
          control={control}
          render={({ field }) => (
            <SimpleInput
              {...field}
              size="sm"
              type="number"
              useSeparator
              precision={2}
              min={0}
              value={field.value?.toString()}
              placeholder="e.g. 1.05"
              width="6rem"
              errorMessage={errors.costMultiplier?.message as string}
            />
          )}
        />
      </Block>
      <Typography variant="body1" color="textTertiary">
        Ex. A multiplier of 1.05 would add an additional 5% to the cost data for all properties. A
        multiplier of 0.98 would decrease the cost data for all properties by 2%.
      </Typography>
    </Flex>
  )
}

